//classes
import Archive from "./classes/archive.es6";
import Single from "./classes/single.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.archive = new Archive();
        this.single = new Single();
    }
}
